import { trpc } from './trpc';
import type { QuickStartChecklistResult } from './setup.types';

export type { QuickStartChecklistResult, QuickStartTaskResult, QuickStartTaskId } from './setup.types';

type QueryOpts = Parameters<typeof trpc.orders.list.useQuery>[1];
type QueryResult<T> = Omit<ReturnType<typeof trpc.orders.list.useQuery>, 'data'> & { data: T | undefined };

type SetupTrpcSlice = {
  setup: {
    checklist: {
      useQuery: (
        input?: { storeId?: string },
        opts?: QueryOpts,
      ) => QueryResult<QuickStartChecklistResult>;
    };
  };
};

const setupTrpc = trpc as typeof trpc & SetupTrpcSlice;

export const useQuickStartChecklist = (storeId?: string, options?: { enabled?: boolean }) =>
  setupTrpc.setup.checklist.useQuery(storeId ? { storeId } : {}, {
    enabled: options?.enabled !== false,
    staleTime: 30_000,
  });

export const useQuickStartSummary = (options?: { enabled?: boolean }) =>
  setupTrpc.setup.checklist.useQuery({}, {
    enabled: options?.enabled !== false,
    staleTime: 60_000,
  });
